var React = require('react');

function DownloadMaterialInline (props) {
    return React.createElement("g",props,[React.createElement("rect",{"x":"-0.10645","width":"48","height":"48","fillRule":"evenodd","clipRule":"evenodd","fill":"none","key":0}),React.createElement("path",{"d":"M23.893549,31.612301l-11.841-11.841002h6.765999v-10.15h10.149v10.15h6.767002\n        L23.893549,31.612301z M42.893551,39.0023h-38v-4h38V39.0023z","fillRule":"evenodd","clipRule":"evenodd","fill":"#F5F2F0","key":1})]);
}

DownloadMaterialInline.defaultProps = {};

module.exports = DownloadMaterialInline;

DownloadMaterialInline.default = DownloadMaterialInline;
